<template>

    <div class="columns">

        <iframe class="column is-full" style="height: 1000px" src="/html/index.html"></iframe>

    </div>

</template>

<script>

export default {
  name: 'Documentation',
}
</script>
